// extracted by mini-css-extract-plugin
export default {"link":"OnboardingLinkButton--link--CSO0X"};